import { render, staticRenderFns } from "./account_son.vue?vue&type=template&id=4aaa9374&scoped=true&"
import script from "./account_son.vue?vue&type=script&lang=js&"
export * from "./account_son.vue?vue&type=script&lang=js&"
import style0 from "./account_son.vue?vue&type=style&index=0&id=4aaa9374&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaa9374",
  null
  
)

export default component.exports